import { render, staticRenderFns } from "./ExistingGroup.vue?vue&type=template&id=56db26ed"
import script from "./ExistingGroup.vue?vue&type=script&lang=js"
export * from "./ExistingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports